import VisualizeSessionType from '../components/course/visualize-session-type';
<template><VisualizeSessionType @model={{@model}} /></template>
